export const Divider = ({ height }) => {
  return <div style={{ height: height }} />;
};
